//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    idfa: {
      type: String,
      default: ''
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancelIdfaFn');
    }
  }
};